module.exports = __webpack_public_path__ + "ttf/OpenSans-CondLight-webfont.b20235.ttf";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondLight-webfont.ttf
 ** module id = 319
 ** module chunks = 12
 **/